import React from "react";
import "./StatusMessage.css";

interface Props {
  message: string;
}

export const StatusMessage: React.FC<Props> = ({ message }) => <h1 className="statusMessage">{message}</h1>;
